import { CatalogType } from '../../models/catalogs.models'

import PageCatalogList from '../../components/page/CatalogList.page'
import { FilterableRoute } from '../../models/commons.models'
const WorkspaceDeconstructionsPage = () => {
  return (
    <PageCatalogList
      withTabs
      withGroups
      types={[CatalogType.deconstruction]}
      filterKey={FilterableRoute.workspaceDeconstructions}
    />
  )
}
export default WorkspaceDeconstructionsPage
